import React from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";

const Navbar = styled.nav`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;

  a {
    flex-grow: 1;
    flex-basis: 0;
    text-align: center;
    font-family: "Gilroy";
    font-weight: bold;
    color: #fff;
  }
  a:not(.active) {
    opacity: 0.5;
  }
`;

const CompfestIcon = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.10667 27.1948C4.84401 27.1986 4.58183 27.1709 4.32569 27.1123C3.91455 27.0017 3.53129 26.8049 3.20108 26.5348C2.75731 26.1851 2.39927 25.7375 2.15457 25.2266C1.96265 24.8007 1.87686 24.3342 1.90465 23.8674C1.91467 23.7105 1.94084 23.5552 1.98275 23.4038C1.99287 23.3643 1.99242 23.3227 1.98145 23.2834C1.97048 23.2441 1.94937 23.2084 1.92027 23.1799C1.52875 22.6402 1.16763 22.0789 0.838616 21.4985C0.817691 21.4701 0.806396 21.4357 0.806396 21.4003C0.806396 21.3649 0.817691 21.3305 0.838616 21.3021C1.01725 21.0124 1.21557 20.7354 1.43216 20.4732C1.62127 20.2393 1.82198 20.0151 2.03351 19.8014L2.0999 19.7347C2.178 19.6561 2.23266 19.6286 2.31467 19.7347C2.76373 20.375 3.20889 20.9603 3.68138 21.5496C4.07187 22.021 4.46236 22.4767 4.87628 22.9245C5.2902 23.3724 5.65726 23.7692 6.0829 24.1699C6.62458 24.7002 7.19283 25.2024 7.78543 25.6744C8.26573 26.0673 8.74994 26.4287 9.25758 26.7666C9.32006 26.8058 9.30053 26.8255 9.25758 26.8687C8.77126 27.3972 8.22621 27.8678 7.63314 28.2711C7.61713 28.2842 7.59714 28.2914 7.57652 28.2914C7.5559 28.2914 7.53591 28.2842 7.5199 28.2711C6.9709 27.9626 6.44142 27.6202 5.93451 27.2458C5.87874 27.1888 5.8082 27.1487 5.7309 27.1299C5.6536 27.1112 5.57263 27.1146 5.49716 27.1398C5.41511 27.1592 5.33145 27.1711 5.24725 27.1751C5.20039 27.1948 5.14962 27.1712 5.10667 27.1948Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.954 10.8458C27.5016 8.27223 26.2118 5.92296 24.2873 4.16744C22.0883 2.0696 19.1682 0.908326 16.1378 0.926479C15.5216 0.923138 14.9062 0.973082 14.2985 1.07576C12.9972 1.28212 11.7386 1.70286 10.5733 2.32107C9.92654 2.66381 9.3145 3.06904 8.74578 3.53103C8.40373 3.80381 8.07655 4.09494 7.76565 4.40314C7.53135 4.65063 7.28144 4.88241 7.05886 5.14169C6.83628 5.40097 6.6918 5.56596 6.51999 5.78595C6.18302 6.22471 5.87517 6.68534 5.59843 7.16483C5.22626 7.80485 4.91384 8.47818 4.66516 9.17619C4.50963 9.60417 4.37924 10.041 4.27467 10.4844C4.16924 10.9558 4.08333 11.435 4.01694 11.9143C3.97399 12.205 3.97009 12.5036 3.94666 12.7982C3.94666 12.8532 3.94666 12.9161 3.94666 12.9711V13.8903C3.97399 13.9532 3.94666 14.0239 3.96618 14.0907C3.97333 14.4539 4.00595 14.8163 4.0638 15.1749C4.11163 15.5588 4.18336 15.9393 4.27857 16.3142C4.2981 16.3888 4.33715 16.4634 4.27857 16.542C4.11847 16.7345 3.95447 16.9348 3.79827 17.1156C3.5628 17.4168 3.34506 17.7316 3.14615 18.0584C3.12933 18.0788 3.12012 18.1045 3.12012 18.1311C3.12012 18.1576 3.12933 18.1833 3.14615 18.2037C3.32187 18.4944 3.49369 18.793 3.67722 19.0798C4.18639 19.8907 4.74727 20.6675 5.35633 21.4054C5.71948 21.8415 6.09045 22.2579 6.46922 22.6743C6.64885 22.8707 6.85971 23.0671 7.04324 23.2439C7.22677 23.4207 7.4845 23.6682 7.71488 23.8725C8.02728 24.1553 8.34748 24.4224 8.67159 24.6856C9.0855 25.0235 9.51504 25.3496 9.9602 25.656C10.4054 25.9624 10.8427 26.2492 11.3035 26.5163C11.341 26.5469 11.3879 26.5636 11.4363 26.5636C11.4846 26.5636 11.5315 26.5469 11.569 26.5163C12.053 26.2028 12.5032 25.8394 12.9123 25.432C12.9474 25.4006 12.9787 25.3613 13.0255 25.3849C13.0724 25.4085 13.1974 25.4203 13.2794 25.4438C13.7047 25.5513 14.1364 25.6313 14.5719 25.6835C14.8921 25.7228 15.2201 25.7267 15.5442 25.7503C15.6457 25.7503 15.7512 25.7503 15.8488 25.7503C15.9396 25.7404 16.0313 25.7404 16.1221 25.7503C16.2237 25.7228 16.3252 25.7503 16.4267 25.7503C16.7001 25.7503 16.9695 25.7188 17.2428 25.6913C17.9027 25.6111 18.5555 25.4798 19.1953 25.2985C20.2183 25.0083 21.198 24.5816 22.1083 24.0296C23.1636 23.3937 24.1158 22.5988 24.9316 21.6725C26.2637 20.2419 27.2349 18.5104 27.7635 16.6236C28.2922 14.7369 28.3629 12.75 27.9696 10.8301L27.954 10.8458ZM23.2681 20.6669C21.9602 22.0306 20.2835 22.9785 18.4455 23.3932C17.5865 23.6069 16.7018 23.6982 15.8176 23.6643C13.3471 23.593 10.9917 22.5986 9.21046 20.8751C7.62029 19.3985 6.55 17.4421 6.16073 15.3006C5.83314 13.7451 5.86895 12.1342 6.26535 10.595C6.66175 9.05572 7.40792 7.63005 8.4451 6.43021C9.86125 4.7605 11.8004 3.62575 13.9432 3.21283C14.7199 3.04167 15.5152 2.97169 16.3096 3.00462C18.5129 3.0672 20.6329 3.8661 22.3348 5.27526C24.1027 6.71046 25.3459 8.69639 25.8688 10.9204C26.0709 11.7402 26.1706 12.5821 26.1655 13.4268C26.1888 16.1348 25.1506 18.7431 23.2759 20.6865L23.2681 20.6669Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9186 5.0294C17.8382 5.02786 19.7007 5.686 21.1977 6.89481C22.6947 8.10362 23.7363 9.79058 24.1501 11.6763C24.642 13.7571 24.3455 15.9477 23.3184 17.8204C23.2127 18.0468 23.0817 18.2603 22.9279 18.4568C22.7089 18.7093 22.4277 18.8994 22.1126 19.008C21.7974 19.1165 21.4594 19.1397 21.1326 19.0752C20.8057 19.0107 20.5014 18.8608 20.2504 18.6405C19.9994 18.4203 19.8104 18.1374 19.7024 17.8204C19.4473 17.0838 18.9182 16.4755 18.2264 16.1233C17.7319 15.8563 17.1746 15.7295 16.6141 15.7565C16.0535 15.7835 15.5108 15.9632 15.0439 16.2765C14.4221 16.6446 13.7249 16.8649 13.0056 16.9207C12.2862 16.9764 11.5638 16.8662 10.8932 16.5982C10.2227 16.3303 9.62191 15.9118 9.13664 15.3747C8.65137 14.8376 8.29447 14.1961 8.09318 13.4991C7.89878 12.8651 7.83317 12.1982 7.90026 11.5382C7.96734 10.8781 8.16575 10.2384 8.48367 9.65709C9.06167 8.50216 9.89635 7.49669 10.923 6.71868C11.9496 5.94067 13.1406 5.41102 14.4035 5.17082C14.5831 5.13547 14.7627 5.10797 14.9463 5.0844C15.2687 5.04356 15.5936 5.02518 15.9186 5.0294ZM19.3588 21.2224C19.6357 21.1613 19.8908 21.0255 20.0968 20.8296C20.2073 20.711 20.2861 20.566 20.3256 20.4084C20.3651 20.2508 20.3641 20.0856 20.3227 19.9285C20.2813 19.7713 20.2009 19.6274 20.089 19.5101C19.977 19.3929 19.8373 19.3062 19.6829 19.2582C19.4602 19.2011 19.2583 19.0811 19.1011 18.9125C18.925 18.719 18.7918 18.49 18.7106 18.2407C18.5784 17.9125 18.3398 17.6389 18.0336 17.4642C17.7274 17.2895 17.3715 17.224 17.0237 17.2783C16.786 17.3209 16.5611 17.4175 16.366 17.5607C16.1709 17.7038 16.0109 17.8898 15.898 18.1045C15.785 18.3192 15.7222 18.557 15.7143 18.7998C15.7064 19.0426 15.7535 19.284 15.8522 19.5057C16.0724 20.0511 16.4511 20.5169 16.9388 20.8422C17.4266 21.1674 18.0006 21.3369 18.5856 21.3285C18.8474 21.3358 19.1086 21.2999 19.3588 21.2224Z"
        fill="white"
      />
    </svg>
  );
};

const CatalogueIcon = () => {
  return (
    <svg
      width="21"
      height="29"
      viewBox="0 0 21 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.55904 28.152L0 25.6346V8.78846L3.55904 10.4007V28.152ZM5.93174 10.5288V28.4723L21.3543 26.1542V8.30443L5.93174 10.5288ZM13.0059 1.18635C10.5182 1.18635 8.31037 3.56497 8.30562 6.24731L8.30443 8.24393C8.30443 8.60577 8.62831 8.88456 8.98658 8.82998C9.27605 8.78609 9.49078 8.53696 9.49078 8.24393V6.24968C9.49434 4.22102 11.1706 2.3727 13.0059 2.3727C13.643 2.3727 14.2113 2.60403 14.6478 3.0418C15.1485 3.54362 15.4237 4.26966 15.4225 5.09062V7.16317C15.4225 7.525 15.7464 7.80379 16.1047 7.74922C16.393 7.70533 16.6065 7.45738 16.6065 7.16554L16.6089 5.09062C16.6112 2.83181 15.0429 1.18635 13.0059 1.18635ZM5.42517 8.2985C5.71582 8.25461 5.93174 8.00547 5.93174 7.71126V5.06333C5.93411 3.03468 7.61161 1.18635 9.44689 1.18635L9.63907 1.20414C10.0733 0.868406 10.5466 0.595546 11.0485 0.393867C10.568 0.148293 10.0306 0 9.44689 0C6.9603 0 4.75132 2.37863 4.74658 5.06096V7.71245C4.74658 8.07547 5.06926 8.3507 5.42517 8.2985Z"
        fill="white"
      />
    </svg>
  );
};

const MissionIcon = () => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4646 0.931152C6.20741 0.931152 0.323486 6.81507 0.323486 14.0722C0.323486 21.3294 6.20741 27.2133 13.4646 27.2133C20.7217 27.2133 26.6056 21.3294 26.6056 14.0722C26.6056 6.81507 20.7217 0.931152 13.4646 0.931152ZM11.3193 19.5477L6.39138 14.818L7.91903 13.2465L11.2919 16.4628L18.9805 8.59678L20.5378 10.1398L11.3193 19.5477Z"
        fill="white"
      />
    </svg>
  );
};

const LeaderboardIcon = () => {
  return (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6657 20.3737C17.2558 15.6961 23.2927 11.8446 23.2927 0.227051H6.70137C6.70137 11.8446 12.7513 15.6961 13.3427 20.3737H16.6657ZM12.3827 6.77827L14.113 6.53888L14.875 4.96744L15.637 6.53888L17.3672 6.77827L16.1075 7.98825L16.4156 9.70783L14.875 8.88419L13.3344 9.70783L13.6425 7.98825L12.3827 6.77827ZM7.8758 11.6704C8.21474 12.4264 8.56908 13.1292 8.92105 13.7834C4.10363 12.1859 1.21674 7.46207 0.775879 2.59725H5.60752C5.65019 3.16846 5.70233 3.72901 5.77225 4.26231H2.58552C3.09156 6.63369 4.42124 9.86663 7.8758 11.6704ZM19.7374 24.6626V26.2992H10.2567V24.6626C12.5569 24.6626 13.0642 22.9643 13.3035 21.5588H16.7C16.9288 22.9655 17.3696 24.6626 19.7374 24.6626ZM29.2182 2.59725C28.7774 7.46207 25.8905 12.1859 21.073 13.7822C21.425 13.128 21.7794 12.4253 22.1183 11.6692C25.5729 9.86663 26.9025 6.6325 27.4086 4.26112H24.223C24.293 3.72783 24.3451 3.16846 24.3878 2.59606H29.2182V2.59725Z"
        fill="white"
      />
    </svg>
  );
};

const navData = [
  {
    key: "dashboard",
    name: "Dashboard",
    link: "/play",
    icon: CompfestIcon,
  },
  {
    key: "catalogue",
    name: "Catalogue",
    link: "/play/catalogue",
    icon: CatalogueIcon,
  },
  {
    key: "mission",
    name: "Mission",
    link: "/play/mission",
    icon: MissionIcon,
  },
  {
    key: "leaderboard",
    name: "Leaderboard",
    link: "/play/leaderboard",
    icon: LeaderboardIcon,
  },
];

export default function PlaygroundNavbar({ active }) {
  return (
    <Navbar>
      {navData.map(data =>
        active === data.key ? (
          <Link to={data.link} key={data.key} className="active">
            <data.icon />
            <div>{data.name}</div>
          </Link>
        ) : (
          <Link to={data.link}>
            <data.icon />
            <div>{data.name}</div>
          </Link>
        )
      )}
    </Navbar>
  );
}
